import { gql } from 'common/generated/gql';

export const REFERRAL_CONSTANTS_FIELDS = gql(/* GraphQL */ `
  fragment ReferralConstantsFields on Constants {
    referralAnnualRewardLimitUsd
    referralV2ProgramLaunchDate
  }
`);

export const REFERRAL_EARNINGS_STATISTICS_FIELDS = gql(/* GraphQL */ `
  fragment ReferralEarningsStatisticsFields on ReferralStatistics {
    creditsEarned
    pendingCount
    earnedCreditsCount
  }
`);

export const REFERRAL_EARNINGS_REDEMPTIONS_FIELDS = gql(/* GraphQL */ `
  fragment ReferralEarningsRedemptionsFields on ReferralRedemption {
    id
    creditsEarned
    creditsEarnedAt
  }
`);

export const REFERRAL_LEGACY_STATISTICS_FIELDS = gql(/* GraphQL */ `
  fragment ReferralLegacyStatisticsFields on ReferralStatistics {
    creditsEarned
    subscribed
    signedUp
  }
`);

export const GET_REFERRAL_DETAILS_QUERY = gql(/* GraphQL */ `
  query Common_GetReferralSettings(
    $statisticsStartDate: DateTime!
    $statisticsEndDate: DateTime!
    $creditPayoutMethod: ReferralPayoutMethod!
  ) {
    constants {
      ...ReferralConstantsFields
    }
    legacyReferralStatistics: referralStatistics {
      ...ReferralLegacyStatisticsFields
    }
    referralStatistics(
      filters: {
        creditPayoutMethod: $creditPayoutMethod
        startDate: $statisticsStartDate
        endDate: $statisticsEndDate
      }
    ) {
      ...ReferralEarningsStatisticsFields
    }
    referralRedemptions(
      filters: { creditPayoutMethod: $creditPayoutMethod, hasEarnedCredits: true }
    ) {
      id
      ...ReferralEarningsRedemptionsFields
    }
  }
`);

export const RESEND_REFERRAL_REWARD_EMAIL = gql(/* GraphQL */ `
  mutation Common_ResendReferralRewardEmail($referralRedemptionId: ID!) {
    resendReferralRewardEmail(referralRedemptionId: $referralRedemptionId) {
      success
      errors {
        ...PayloadErrorFields
      }
    }
  }
`);
